import React, { useMemo } from "react";
import { FieldGroup } from "../../components";
import { DataHelper } from "../../helpers";
import { Window } from "../../contexts";

const BusinessExpert = ({ user, isProfile, isRC }) => {
  const prependBusinessCityStaticOptions = useMemo(
    () =>
      user?.business_city
        ? [{ id: user.business_city.id, name: user.business_city.city }]
        : [],
    [user]
  );

  return (
    <div>
      {/* On create (no user yet) Contact owner sits in the Overview head. */}
      {!isProfile && user && !user.is_sales_admin && (
        <div className="row">
          <div className="col-md-6 pr-16">
            <FieldGroup
              placeholder="Contact owner"
              type="select"
              name="owner_id"
              optionsUrl={`/api/users/sales-admins`}
              optionsMethod="post"
              disabled={isRC}
            />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-6 pr-16">
          <FieldGroup placeholder="Job Title" name="title" />
          <FieldGroup
            placeholder="Company Url"
            name="company_url"
            disabled={isRC}
          />
          <FieldGroup
            placeholder="Environment"
            type="select"
            name="work_environment"
            options={DataHelper.environments}
            disabled={isRC}
          />
          <FieldGroup
            placeholder="Store (google)"
            name="store_google"
            disabled={isRC}
          />
        </div>

        <div className="col-md-6">
          <FieldGroup placeholder="Company" name="company" readOnly={isRC} />
          <FieldGroup
            placeholder="Business City"
            type="select"
            name="business_city_id"
            optionsUrl={`/api/cities`}
            prependStaticOptions={prependBusinessCityStaticOptions}
            disabled={isRC}
          />
          <FieldGroup
            placeholder="Main Duty"
            type="select"
            name="work_role"
            options={DataHelper.duties}
            disabled={isRC}
          />
        </div>
      </div>
      <div>
        <FieldGroup
          label="Work expertise"
          name="expert_categories"
          type="multiselect"
          maxSelections={2}
          options={Window.CATEGORIES}
          disabled={isRC}
        />
      </div>
    </div>
  );
};

export default BusinessExpert;
